<template>
  <div id="invoice_application_dialog_outer">
    <div>

<!--      <div class="invoice-item">-->
<!--        <div>发票类型：</div>-->
<!--        <div>-->
<!--          <el-radio v-model="invoiceItem.invoiceValue" :label="1">无需发票</el-radio>-->
<!--          <el-radio v-model="invoiceItem.invoiceValue" :label="2" >纸质发票</el-radio>-->
<!--        </div>-->
<!--      </div>-->
      <div class="invoice-title">
        发票申请
      </div>
      <div class="invoice-top-desc">
        1.发票审核完成后不可修改，如因填写错误导致开具、寄送问题，将无法重开。<br>
        2.因三证合一问题导致税务变更，请先和公司财务确认清楚，税号确认错误将无法重开。<br>
        3.提交完成后，纸质发票将在30个工作日左右开具并寄出。
      </div>

      <div v-if="invoiceItem.invoiceValue != 1" class="invoice-item">
        <div>抬头类型：</div>
        <div>
          <el-radio v-model="invoiceItem.invoiceTitleValue" :label="1" >企业单位</el-radio>
          <el-radio v-model="invoiceItem.invoiceTitleValue" :label="2">个人/非企业单位</el-radio>
        </div>
      </div>

      <div class="invoice-item">
        <div style="align-self: center;">发票抬头：</div>
        <div>
          <el-input v-model="invoiceItem.invoiceTitle" :placeholder="invoiceItem.invoiceTitleValue == 2 ? '请填入开票人姓名'  : '请填入开票企业名称'" />
        </div>
      </div>

      <div v-if=" invoiceItem.invoiceTitleValue != 2" class="invoice-item">
        <div style="align-self: center;" >纳税人识别号：</div>
        <div>
          <el-input v-model="invoiceItem.invoiceNO" placeholder="请填写纳税人识别号" />
        </div>
      </div>

      <div class="invoice-item">
        <div style="align-self: center;" >发票内容：</div>
        <div>
          <el-radio v-model="invoiceItem.invoiceContent" :label="1" >会员服务费</el-radio>
        </div>
      </div>

      <div class="invoice-item" v-if="false">
        <div style="align-self: center;">收件人：</div>
        <div>
          <el-input v-model="invoiceItem.contacts" placeholder="请填写收件人姓名" />
        </div>
      </div>

      <div class="invoice-item" v-if="false">
        <div style="align-self: center;">电话：</div>
        <div>
          <el-input v-model="invoiceItem.tel" placeholder="请填写收件人电话" />
        </div>
      </div>

      <div class="invoice-item" v-if="false">
        <div style="align-self: center;">收件人：</div>
        <div>
          <el-input v-model="invoiceItem.address" placeholder="请填写收件人地址" />
        </div>
      </div>

      <div class="invoice-item" style="margin-top: 50px;">
        <div style="align-self: center;"></div>
        <div >
          <el-button id="invoice_submit" round @click="submitButtonClicked">提交</el-button>
        </div>
      </div>

      <a class="iconfont close-button" href="javascript:void(null);"
         @click="closeButtonClicked">&#xe639;</a>

    </div>
  </div>
</template>

<script>
export default {
  name: "InvoiceApplicationDialog",
  data() {
    return {
      changed: false,
      invoiceItem: {
        invoiceTitleValue: 1,
        invoiceTitle: '',
        invoiceNO: '',
        invoiceContent: 1,
        contacts: '',
        tel: '',
        address: ''
      },
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },

  mounted() {
    console.log(this.user);
  },
  methods: {
    closeButtonClicked() {
      if (this.changed) {
        let _this = this;
        this.$confirm('您的签名尚未上传，确定退出吗？', '提示', {
          confirmButtonText: '退出',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          _this.$emit('close');
        }).catch(() => {
          console.log('不退出');
        })
      } else {
        this.$emit('close');
      }
    },
    submitButtonClicked() {

      let params = {};
      let invoiceItem = this.invoiceItem;

      params.id = 0;
      let invoiceTitle = invoiceItem.invoiceTitle.removeBlanks();
      if (invoiceTitle == '') {
        this.$toast('请输入发票抬头！');
        return;
      }
      params.title = invoiceTitle;

      let invoiceTitleValue = invoiceItem.invoiceTitleValue;
      params.type = invoiceTitleValue;
      if (invoiceTitleValue == 1) {
        let invoiceNO = invoiceItem.invoiceNO.removeBlanks();
        if (invoiceNO == '') {
          this.$toast('请输入纳税人识别号！');
          return;
        }
        params.taxNumber = invoiceNO;
      }

      // let contacts = invoiceItem.contacts.removeBlanks();
      // if (contacts == '') {
      //   this.$toast('请输入收件人姓名！');
      //   return;
      // }
      // params.addressee = contacts;
      params.addressee = null;

      // let tel = invoiceItem.tel.removeBlanks();
      // if (tel == '') {
      //   this.$toast('请输入收件人电话！');
      //   return;
      // }
      // params.tel = tel;
      params.tel = null;
      // let address = invoiceItem.address.removeBlanks();
      // if (address == '') {
      //   this.$toast('请输入收件人地址！');
      //   return;
      // }
      // params.address = address;
      params.address = null;
      let userId = this.user.id;
      params.userId = userId;

      this.$emit('submitInvoiceData', params);
    },
  }
}
</script>

<style scoped>

  #invoice_application_dialog_outer {
    background-color: rgba(0,0,0,0.3);
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999;
  }

  #invoice_application_dialog_outer > div {
    background-color: white;
    position: absolute;

    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    padding-top: 30px;
    padding-bottom: 30px;
    max-height: 100vh;
    overflow-y: auto;
  }


  #invoice_application_dialog_outer .close-button {
    position: absolute;
    top: 0;
    right: 3px;
    color: black;
    font-size: 2rem;
    text-decoration: none;
    z-index: 100;
  }


  #invoice_application_dialog_outer .invoice-item {
    width: 97vw;
    max-width: 700px;
    min-width: 310px;
    padding-right: 5px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 15px;
    /*background-color: yellow;*/
  }

  #invoice_application_dialog_outer .el-input {
    max-width: 400px;
  }

  #invoice_application_dialog_outer /deep/ .el-input__inner:focus {
    border: solid 1px #fc1a34;
  }

  #invoice_application_dialog_outer .invoice-item > div:first-child {
    width: 32%;
    text-align: right;
  }

  #invoice_application_dialog_outer .invoice-item > div:last-child {
    width: 63%;
    margin-left: 5%;
  }

  #invoice_application_dialog_outer  /deep/ .el-radio .el-radio__input .el-radio__inner:hover {
    border-color: #fc1a34;
  }

  #invoice_application_dialog_outer  /deep/ .el-radio .el-radio__label {
    padding-left: 5px;
  }

  #invoice_application_dialog_outer  /deep/ .el-radio.is-checked .el-radio__input .el-radio__inner {
    border-color: #fc1a34;
    background-color: #fc1a34;
  }
  #invoice_application_dialog_outer  /deep/ .el-radio.is-checked .el-radio__label {
    color: #fc1a34;
  }

  #invoice_submit {
    background-color: #fc1a34;
    border-color: #fc1a34;
    color: white;
    width: 100%;
    max-width: 300px;
  }

  #invoice_submit:hover {
    color: #eee;
  }

  #invoice_application_dialog_outer .invoice-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
  }

  #invoice_application_dialog_outer .invoice-top-desc {
    width: 100%;
    text-align: left;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 20px;
  }


  @media screen and (min-width: 768px){
    #invoice_application_dialog_outer .invoice-item > div:first-child {
      width: 30%;
      text-align: right;
    }

    #invoice_application_dialog_outer .invoice-item > div:last-child {
      width: 60%;
      margin-left: 5%;
    }

    #invoice_application_dialog_outer  /deep/ .el-radio .el-radio__label {
      padding-left: 10px;
    }

    #invoice_application_dialog_outer .invoice-top-desc {
      width: 90%;
      text-align: left;
      padding-left: 30px;
      padding-right: 30px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/InvoiceApplicationDialog.vue